<dx-popup
  [width]="950"
  [height]="700"
  [showTitle]="true"
  class="intervention-report-popup"
  [title]="title"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [elementAttr]="{ class: 'intervention-report-popup' }"
  (onHidden)="closed($event)"
  (onShowing)="onShowing($event)"
  (onShown)="onShown($event)"
  [(visible)]="visible">
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Fermer',
            onClick: close
        }">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <dx-tabs
      [dataSource]="[{id: 0, text: 'Rapport'}, {id: 1, text: 'La Carte'}]"
      [selectedIndex]="0"
      (onItemClick)="selectTab($event)"
    ></dx-tabs>
    <div *ngIf="selectedTab === 0">
      <div class="p-4">
        <h3 class="font-light border-b border-gray-300 mb-2">
          Parcelle {{intervention.field.name}} <span class="float-right text-base">{{intervention.start_time | date :'shortTime'}}
          - {{intervention.stop_time | date :'shortTime'}} ({{intervention.start_time | date :'shortDate'}})</span></h3>
        <div class="grid p-1 grid-cols-4 gap-3 history-metrics">
          <div title="Superficie" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Totale</div>
            <span class="metric-value">{{intervention.field.polygonAreaToHa().toFixed(2)}} <span
              class="metric-unit">Ha</span></span>
          </div>
          <div title="Superficie Travaillée" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Travaillée</div>
            <span class="metric-value">{{intervention.working_area_ha.toFixed(2)}} <span
              class="metric-unit">Ha</span></span>
          </div>
          <div title="Percentage" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Percentage</div>
            <span class="metric-value">{{(intervention.working_area_percent * 100).toFixed(1)}} <span
              class="metric-unit">%</span></span>
          </div>
          <div title="Débit" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Débit</div>
            <span class="metric-value">{{intervention.working_hectare_per_hour.toFixed(2)}} <span
              class="metric-unit">Ha/h</span></span>
          </div>
        </div>
      </div>
      <div class="p-4 pt-0">
        <div class="grid grid-cols-2 gap-3">
          <div>
            <h3 class="font-light border-b border-gray-300 mb-2">Vitesse Travail</h3>
            <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
              <div title="Moyenne" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Moyenne</div>
                <span class="metric-value">{{intervention.working_in_field_speed_avg.toFixed(2)}} <span
                  class="metric-unit">Km/h</span></span>
              </div>
              <div title="Maximale" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Maximale</div>
                <span class="metric-value">{{intervention.working_in_field_speed_max.toFixed(2)}} <span
                  class="metric-unit">Km/h</span></span>
              </div>
            </div>
            <h3 class="font-light border-b border-gray-300 mt-4 mb-2">Machines & Outils</h3>
            <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
              <div title="Tracteur" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Tracteur</div>
                <span class="metric-value">{{intervention.tractor_name}}</span>
              </div>
              <div title="Outil" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Outil</div>
                <span class="metric-value">{{intervention.trailer_name}}</span>
              </div>
              <div title="Largeur de Travail" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Largeur de Travail</div>
                <span class="metric-value">{{(intervention.trailer_width / 100).toFixed(2)}} <span
                  class="metric-unit">m</span></span>
              </div>
            </div>
          </div>
          <app-time-pie-chart title="Temps" [data]="timeReport"></app-time-pie-chart>
        </div>
      </div>
    </div>
    <div style="position: relative" [ngClass]="{'invisible': selectedTab !== 1}">
      <div id="intervention-report-map" class="intervention-report-map"
           leaflet
           [leafletOptions]="mapOptions"
           (leafletMapReady)="onMapReady($event)">
      </div>
      <app-map-layers-control [mapReady]="mapReady$" [layers]="layers"></app-map-layers-control>
    </div>
  </div>
</dx-popup>
